(function () {

  function beforeAfterInit() {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.before-after-scrubber').forEach(function(scrubber) {
        var range = scrubber.querySelector('.scrubber-range');
        var beforeWrapper = scrubber.querySelector('.before-image-wrapper');
        if (range && beforeWrapper) {
          range.addEventListener('input', function() {
            var percent = range.value;
            beforeWrapper.style.width = percent + '%';
          });
        }
      });
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    beforeAfterInit();
  });

  beforeAfterInit();
})();
